import { cn } from '../../utils/cn';

/**
 * Tabs — yatay sekme component.
 * tabs: [{ key, label, count?, hasError? }]
 *
 * Stil: Zuzzuu_2.0/shared/components/Tabs ile hizalanmış:
 *   - 3 px alt çizgi aktif sekme için (primary brand blue)
 *   - Aktif metin koyu neutral (shared "text-[#1C1C1D]" ≈ text-neutral-900)
 *   - Pasif metin orta gri (shared "text-[#777]" ≈ text-neutral-500)
 *   - hasError=true ise label yanına kırmızı nokta (#FD5995) gösterilir;
 *     tab form bölümlerindeki validasyon hatasını üst seviyede işaretler.
 */
export default function Tabs({ tabs, value, onChange, className }) {
  return (
    <div className={cn('border-b border-neutral-200', className)}>
      <nav className="-mb-px flex gap-6 overflow-x-auto">
        {tabs.map((t) => {
          const active = value === t.key;
          return (
            <button
              key={t.key}
              type="button"
              onClick={() => onChange(t.key)}
              className={cn(
                'whitespace-nowrap border-b-[3px] py-3 text-sm transition-colors',
                active
                  ? 'border-primary-600 font-medium text-neutral-900'
                  : 'border-transparent font-normal text-neutral-500 hover:border-neutral-300 hover:text-neutral-700',
              )}
            >
              <span className="inline-flex items-center gap-1.5">
                {t.label}
                {t.hasError && (
                  <span
                    className="h-1.5 w-1.5 rounded-full bg-[#FD5995]"
                    aria-label="bu sekmede doğrulama hatası var"
                    title="Bu sekmede doğrulama hatası var"
                  />
                )}
              </span>
              {typeof t.count === 'number' && (
                <span
                  className={cn(
                    'ml-2 rounded-full px-2 py-0.5 text-xs',
                    active ? 'bg-primary-50 text-primary-700' : 'bg-neutral-100 text-neutral-600',
                  )}
                >
                  {t.count}
                </span>
              )}
            </button>
          );
        })}
      </nav>
    </div>
  );
}
